import React from "react";
import { connect } from "react-redux";
import { addClient, IClient } from "../../../redux/modules/clients";
import ClientForm from "../../ClientForm";
import history from "../../../history";
import "./create-client.css";

interface CreateClientProps {
  addClient?: (client: IClient, callBack: (savedClient: IClient) => void) => Promise<void>;
}

class CreateClientPage extends React.Component<CreateClientProps> {
  saveClientHandler = (client: IClient) => {
    this.props.addClient && this.props.addClient(client, (savedClient: IClient) => history.push(`/client/${savedClient.id}`));
  };

  render() {
    return (
      <div className="create-client">
        <div className="create-client__header">
          <h1 className="create-client__title">Додати Клієнта</h1>
          <p className="create-client__subtitle">Заповніть інформацію про нового клієнта</p>
        </div>
        <div className="create-client__form-container">
          <ClientForm saveHandler={this.saveClientHandler} />
        </div>
      </div>
    );
  }
}

export default connect(null, { addClient })(CreateClientPage);